import { Injectable } from '@angular/core';
import { AbstractService } from '../common/abstract.service';
import { HttpClient } from '@angular/common/http';
import { ServiceErrorHandler } from 'src/app/decorator/service-error-handler-decorator';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedProjectService extends AbstractService {

  constructor(private http: HttpClient) {
    super();
  }

  @ServiceErrorHandler()
  getSharedProjects(): Observable<any> {
    return this.http.get('/api/shared-projects?is_mine=1', this.httpOptions);
  }

  @ServiceErrorHandler()
  createProjectConnection(data: any): Observable<any> {
    return this.http.post('/api/shared-projects', data, this.httpOptions);
  }
  
  @ServiceErrorHandler()
  updateBulkSharedItems(type: string , data: any): Observable<any> {
    return this.http.post(`/api/shared-items/bulk/${type}`, data, this.httpOptions);
  }
  
  @ServiceErrorHandler()
  updateSharedProjectDetail(id: number, data: any): Observable<any> {
    return this.http.put(`/api/shared-projects/${id}`, data, this.httpOptions);
  }
  
  @ServiceErrorHandler()
  getProjectDetail(id: number): Observable<any> {
    return this.http.get(`/api/shared-projects/${id}`, this.httpOptions);
  }

  @ServiceErrorHandler()
  getAllMessages(type,id,page) {
    return this.http.get(`/api/projects-comments?type=${type}&type_id=${id}&page=${page}&count=400`,this.httpOptions);
  }
  
  @ServiceErrorHandler()
  getAllInternalSubprojectMessages(type,id,page) {
    return this.http.get(`/api/comments?type=${type}&type_id=${id}&page=${page}&count=400`,this.httpOptions);
  }

  @ServiceErrorHandler()
  sendMessages(type,id,page,data) {
    return this.http.post(`/api/projects-comments?type=${type}&type_id=${id}`,data,this.httpOptions);
  }

  @ServiceErrorHandler()
  sendInternalSubprojectMessages(type,id,page,data) {
    return this.http.post(`/api/comments?type=${type}&type_id=${id}`,data,this.httpOptions);
  }

  @ServiceErrorHandler()
  getSharedStatus(type): Observable<any> {
    return this.http.get(`/api/shared-projects?${type}=1`, this.httpOptions);
  }
  
  @ServiceErrorHandler()
  getCancelledSharedProjects(): Observable<any> {
    return this.http.get(`/api/shared-projects?status=cancelled&is_mine=1`, this.httpOptions);
  }

  @ServiceErrorHandler()
  getAllCollaborators(type,id) {
    return this.http.get(`/api/projects-collaborators?type=${type}&type_id=${id}`,this.httpOptions);
  }

  @ServiceErrorHandler()
  saveCollaborators(type,id,data) {
    return this.http.post(`/api/projects-collaborators?type=${type}&type_id=${id}`,data,this.httpOptions);
  }

  @ServiceErrorHandler()
  getAllSharedItems(type) {
    return this.http.get(`/api/shared-items?item_type=${type}`,this.httpOptions);
  }
}
